import {Component, Input, OnInit} from '@angular/core';
import { Nom035Service } from '../../../../services/nom035.service';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { EmployeeService } from '../../../../employee.service';
import { StationService } from '../../../../services/stations.service';

@Component({
  selector: 'ngx-results',
  templateUrl: './results.component.html',
  styleUrls: ['./results.component.scss'],
})
export class ResultsComponent implements OnInit {
  @Input() stationId;
  constructor(
    private nom035Service: Nom035Service,
    private employeeService: EmployeeService,
    private stationService: StationService,
    ) {
      this.stationService.change.subscribe(async (station: any) => {
        this.stationId = station;
        this.init();
      });
    }

  showResult = '';
  loading = false;
  categories = [];
  categoriesFormatted = [];
  domains = [];
  domainsFormatted = [];

  categoriesFormattedByStation = [];
  domainsFormattedByStation = [];

  dataAverageStation = {
    questionnaires: 0,
    total: 0,
    average: 0,
    result: '',
  };

  selectedEmployeeId = 0;
  employees = [];
  codeHtmlCheck = '<i class="fas fa-check-circle text-success"></i>';
  qualificationFinal = { total: 0, result: '' };

  async ngOnInit() {
    this.init();
  }

  async init() {
    this.loading = true;
    await this.getGroupsByDomain();
    await this.getGroupsByCategory();
    await this.getQualificationGeneralStation();
    await this.getEmployeesByStationId();
    this.loading = false;
  }

  async getQualificationGeneralStation() {
    const [err, response]: any = await this.nom035Service.getQualificationGeneralStation(this.stationId);
    if (err) return this.alert('Oops, intenta más tarde', 'error', 'Error. Cargar calificación general de la estación');
    this.dataAverageStation.total = 0;
    const questionnaires = response.data;
    const data = { rows: [], categories: [], domains: [] };
    for await (const questionnaire of questionnaires) {
      data.rows = await this.calculateTotal(this.domains, questionnaire.questions, data.rows);
      data.rows = await this.calculateTotal(this.categories, questionnaire.questions, data.rows);
    }

    for await (const row of data.rows) {
      if (row.type === 'domain') {
        row.total = (row.total / questionnaires.length);
        const searchDomain = await data.domains.find((domain) => domain.id === row.id);
        if (searchDomain) searchDomain.total += row.total;
          else data.domains.push(row);
      }

      if (row.type === 'category') {
        const searchCategories = await data.categories.find((category) => category.id === row.id);
        if (searchCategories) searchCategories.total += row.total;
          else data.categories.push(row);
      }
    }

    for (const row of data.domains) {
      row.total = Math.round(row.total);
      this.dataAverageStation.total += row.total;
      if (row.total < row.qualification[0]) {
        this.domainsFormattedByStation.push({ ...row, result: 'nulo' });
      } else if (row.total <= row.qualification[0] || row.total < row.qualification[1]) {
        this.domainsFormattedByStation.push({ ...row, result: 'bajo' });
      } else if (row.total <= row.qualification[1] || row.total < row.qualification[2]) {
        this.domainsFormattedByStation.push({ ...row, result: 'medio' });
      } else if (row.total <= row.qualification[2] || row.total < row.qualification[3]) {
        this.domainsFormattedByStation.push({ ...row, result: 'alto' });
      } else if (row.total >= row.qualification[3]) {
        this.domainsFormattedByStation.push({ ...row, result: 'muy alto' });
      }
    }

    for (const row of data.categories) {
      row.total = Math.round(row.total);
      this.dataAverageStation.total += row.total;
      if (row.total < row.qualification[0]) {
        this.categoriesFormattedByStation.push({ ...row, result: 'nulo' });
      } else if (row.total <= row.qualification[0] || row.total < row.qualification[1]) {
        this.categoriesFormattedByStation.push({ ...row, result: 'bajo' });
      } else if (row.total <= row.qualification[1] || row.total < row.qualification[2]) {
        this.categoriesFormattedByStation.push({ ...row, result: 'medio' });
      } else if (row.total <= row.qualification[2] || row.total < row.qualification[3]) {
        this.categoriesFormattedByStation.push({ ...row, result: 'alto' });
      } else if (row.total >= row.qualification[3]) {
        this.categoriesFormattedByStation.push({ ...row, result: 'muy alto' });
      }
    }

    this.dataAverageStation.questionnaires = response.data.length;
    this.dataAverageStation.average = Math.round(this.dataAverageStation.total / this.dataAverageStation.questionnaires);
    const qualification = [20, 45, 70, 90];
    if (this.dataAverageStation.average < qualification[0]) {
      this.dataAverageStation.result = 'nulo';
    } else if (this.dataAverageStation.total <= qualification[0] && this.dataAverageStation.total < qualification[1]) {
      this.dataAverageStation.result = 'bajo';
    } else if (this.dataAverageStation.total <= qualification[1] && this.dataAverageStation.total < qualification[2]) {
      this.dataAverageStation.result = 'medio';
    } else if (this.dataAverageStation.total <= qualification[2] && this.dataAverageStation.total < qualification[3]) {
      this.dataAverageStation.result = 'alto';
    } else if (this.dataAverageStation.total >=  qualification[3]) {
      this.dataAverageStation.result = 'muy alto';
    }
  }

  async getEmployeesByStationId() {
    const [err, result] = await this.employeeService.getEmployees(this.stationId);
    if (err) return this.alert('Oops, intenta más tarde', 'error', 'Error. Lista empleados');
    this.employees = result.data;
  }

  async getFormNom035ByEmployee() {
    this.categoriesFormatted = [];
    this.domainsFormatted = [];
    this.qualificationFinal = { total: 0, result: '' };
    if (!this.selectedEmployeeId) return;
    this.loading = true;
    const [err, response]: any = await this.nom035Service.getQuestionsByEmployeeId(this.selectedEmployeeId);
    this.loading = false;
    if (err) return this.alert('Oops, intenta más tarde', 'error', 'Error. cargar cuestionario');
    if (response.data && response.data.questions) {
      this.domainsFormatted = await this.formatDataQualification(this.domains, response.data.questions);
      this.categoriesFormatted = await this.formatDataQualification(this.categories, response.data.questions);
      return this.calculateQualificationFinal();
    }
    return this.alert('No se ha realizado el cuestionario', 'error');
  }

  async getGroupsByCategory() {
    this.loading = true;
    const [err, response]: any = await this.nom035Service.getGroupsByCategory('category');
    this.loading = false;
    if (err) return this.alert('Oops, intenta más tarde', 'error', 'Error. cargar categorias');
    this.categories = response.data;
  }

  async getGroupsByDomain() {
    this.loading = true;
    const [err, response]: any = await this.nom035Service.getGroupsByCategory('domain');
    this.loading = false;
    if (err) return this.alert('Oops, intenta más tarde', 'error', 'Error. cargar dominios');
    this.domains = response.data;
  }

  async calculateTotal(rows: any, questions: any, data: any) {
    for await (const row of rows) {
      let total = 0;
      for await (const item of row.item) {
        const question: any = await questions.find((q: any) => q.id === item);
        total += Number(question.response);
      }
      data.push({ ...row, total});
    }
    return data;
  }

  async formatDataQualification (rows: any, questions: any) {
    const dataWithQualification = [];
    for await (const row of rows) {
      let total = 0;
      for await (const item of row.item) {
        const question: any = await questions.find((q: any) => q.id === item);
        total += Number(question.response);
      }
      this.qualificationFinal.total += total;
      if (total < row.qualification[0]) {
        dataWithQualification.push({ ...row, total, result: 'nulo' });
      } else if (total <= row.qualification[0] || total < row.qualification[1]) {
        dataWithQualification.push({ ...row, total, result: 'bajo' });
      } else if (total <= row.qualification[1] || total < row.qualification[2]) {
        dataWithQualification.push({ ...row, total, result: 'medio' });
      } else if (total <= row.qualification[2] || total < row.qualification[3]) {
        dataWithQualification.push({ ...row, total, result: 'alto' });
      } else if (total >= row.qualification[3]) {
        dataWithQualification.push({ ...row, total, result: 'muy alto' });
      }
    }// 1er for
    return dataWithQualification;
  }

  async calculateQualificationFinal() {
    const qualification = [20, 45, 70, 90];
    if (this.qualificationFinal.total < qualification[0]) {
      this.qualificationFinal.result = 'nulo';
    } else if (this.qualificationFinal.total <= qualification[0] && this.qualificationFinal.total < qualification[1]) {
      this.qualificationFinal.result = 'bajo';
    } else if (this.qualificationFinal.total <= qualification[1] && this.qualificationFinal.total < qualification[2]) {
      this.qualificationFinal.result = 'medio';
    } else if (this.qualificationFinal.total <= qualification[2] && this.qualificationFinal.total < qualification[3]) {
      this.qualificationFinal.result = 'alto';
    } else if (this.qualificationFinal.total >=  qualification[3]) {
      this.qualificationFinal.result = 'muy alto';
    }
  }

  async alert(title: string = 'text', type: SweetAlertIcon = 'success', text: string = '') {
    await Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }
}
